import React, { useState, useEffect } from 'react';
import config from '../config';
import './PasswordProtection.css';

interface PasswordProtectionProps {
  onAuthenticated: () => void;
}

const PasswordProtection: React.FC<PasswordProtectionProps> = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if already authenticated
    const authExpiry = localStorage.getItem('authExpiry');
    if (authExpiry && new Date().getTime() < parseInt(authExpiry)) {
      console.log('Found valid authentication token, proceeding...');
      onAuthenticated();
    } else {
      console.log('No valid authentication token found');
    }
  }, [onAuthenticated]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Checking password...');
    if (password === config.auth.password) {
      console.log('Password correct, setting authentication...');
      // Set authentication expiry to 30 days from now
      const expiryDate = new Date().getTime() + (30 * 24 * 60 * 60 * 1000);
      localStorage.setItem('authExpiry', expiryDate.toString());
      onAuthenticated();
    } else {
      console.log('Incorrect password');
      setError('Incorrect password');
    }
  };

  return (
    <div className="password-protection">
      <div className="password-form">
        <h2>Enter Password</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            required
          />
          {error && <p className="error">{error}</p>}
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default PasswordProtection; 